import { AnpPricePoint } from "../types/anpReports.type";

export const formatGeoName = (price: AnpPricePoint) => {
  if (!price.geo) {
    return '--';
  }

  const cityAcronym = price.geo?.state?.acronym;

  if (price.geo_type === 'Geo::City' && cityAcronym) {
    return `${price.geo.display_name}/${cityAcronym}`;
  }

  return price.geo.display_name || '--';
};
